import types from "./types";
import service from "./service";

const send_create_scratch_po_job = (run_id, fn) => {
    return dispatch => {
        dispatch({type: types.SEND_CREATE_SCRATCH});
        service.send_create_scratch_po_job(run_id)
            .then(result => {
                fn && fn(true, result);
                dispatch({
                    type: types.SEND_CREATE_SCRATCH_SUCCESS,
                    payload: result
                });
            })
            .catch(error => {
                if (error.response) {
                    fn && fn(false, error);
                }
                dispatch({
                    type: types.SEND_CREATE_SCRATCH_FAIL,
                    payload: error
                });
            });
    };
};

const send_grn_job = (runID, items=null) => {
    return dispatch => {
        dispatch({type: types.SEND_GRN_JOB});
        return service.send_grn_job(runID, items)
            .then(result => {
                dispatch({
                    type: types.SEND_GRN_JOB_SUCCESS,
                });
                return result;
            })
            .catch(error => {
                dispatch({
                    type: types.SEND_GRN_JOB_FAIL,
                    payload: error
                });
            });
    };
};

//THIS IS FOR GRN AND GRN REVERSAL, AND CANCEL PO
const send_items_selected_job = (runID, data=null, path) => {
    return dispatch => {
        dispatch({type: types.SEND_ITEMS_SELECTED_JOB});
        return service.send_items_selected_job(runID, data, path)
            .then(result => {
                dispatch({
                    type: types.SEND_ITEMS_SELECTED_JOB_SUCCESS,
                });
                return result;
            })
            .catch(error => {
                dispatch({
                    type: types.SEND_ITEMS_SELECTED_JOB_FAIL,
                    payload: error
                });
            });
    };
};
const get_sap_history = (runID) => {
    return dispatch => {
        dispatch({type: types.GET_GRN_HISTORY});
        return service.get_sap_history(runID)
            .then(result => {
                dispatch({
                    type: types.GET_GRN_HISTORY_SUCCESS,
                });
                return result;
            })
            .catch(error => {
                dispatch({
                    type: types.GET_GRN_HISTORY_FAIL,
                    payload: error
                });
            });
    };
};

export default {
    send_create_scratch_po_job,
    send_grn_job,
    get_sap_history,
    send_items_selected_job,
};
